import { PickersTextField } from '@mui/x-date-pickers-pro'
import { styled } from '@mui/material'

const StyledPickersTextField = styled(PickersTextField)(props => {
  const { theme, size, defaultSize = false, disabled, InputProps } = props
  return {
    '& .MuiFormLabel-root.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      // Since we are not using MUI default sizes, so adjusting the label according to the height
      ...(!defaultSize && {
        transform: size === 'small' ? 'translate(14px, 7px) scale(1)' : 'translate(14px, 11px) scale(1)',
      }),
    },
    '.MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
      height: 40,
      padding: '12px 0',
      ...(size === 'small' && { height: 32, padding: '8px 0' }),
      ...(size === 'medium' && { height: 40, padding: '12px 0' }),
    },
    '& .MuiPickersOutlinedInput-root': {
      backgroundColor: disabled || InputProps?.readOnly ? theme.palette.background.disabled : theme.palette.background.paper,
      '&.Mui-disabled fieldset': {
        borderColor: theme.palette.grey['300'],
      },
      '& fieldset': {
        borderColor: theme.palette.grey['300'],
      },
      '&:hover fieldset': {
        borderColor: theme.palette.grey['300'],
      },
      '&.Mui-focused fieldset': {
        borderColor: InputProps?.readOnly ? theme.palette.grey['300'] : theme.palette.primary.main,
        borderWidth: InputProps?.readOnly ? 1 : 2,
      },
      '&.Mui-focused.Mui-error fieldset': {
        borderColor: theme.palette.error.main,
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent',
      },
    },
  }
})

export default StyledPickersTextField
